import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { ClearOutlined, CloseOutlined, SyncOutlined } from "@ant-design/icons";
import { Dropdown, Space, ConfigProvider } from "antd";
import { useContext, useEffect, useState } from "react";
import { BarStyle } from "./styles";
import { generatePath, matchRoutes, useLocation, useNavigate } from "react-router-dom";
import { useMemoizedFn } from "ahooks";
import { getChildPathname, noticeSubAppRemovePanes } from "../../../utils";
import { routesArraySelector, sendMessage, useAppStore, useMicroAppStore } from "../../../store";
import { findIntlKeyByAntdLocaleKey, intlMap } from "../../../locales";
import DropdownArrow from "../../../components/icons/DropdownArrow";
import { jsx as _jsx } from "react/jsx-runtime";
var OperationRight = function OperationRight() {
  var _antdConfig$locale;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    tabHandlersDropdownOpen = _useState2[0],
    setTabHandlersDropdownOpen = _useState2[1];
  var setPageHandlers = useAppStore(function (state) {
    return state.setPageHandlers;
  });
  var _useAppStore = useAppStore(function (s) {
      return s.tabCacheHandlers;
    }),
    cleanOtherCache = _useAppStore.cleanOtherCache;
  var removeHistory = useAppStore(function (state) {
    return state.removeHistory;
  });
  var homePath = useAppStore(function (state) {
    return state.homePath;
  });
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var tabsLocale = useAppStore(function (state) {
    return state.locale;
  });
  var setPanes = useAppStore(function (state) {
    return state.setPanes;
  });
  var panes = useAppStore(function (state) {
    return state.panes;
  });
  var microApps = useMicroAppStore(function (s) {
    return s.microApps;
  });
  var setRefreshPath = useAppStore(function (s) {
    return s.setRefreshPath;
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var routesPaths = useAppStore(routesArraySelector);
  var _ref = matchRoutes(routesPaths, pathname) || [],
    _ref2 = _slicedToArray(_ref, 1),
    matchRoute = _ref2[0];
  var antdConfig = useContext(ConfigProvider.ConfigContext);
  var localeString = findIntlKeyByAntdLocaleKey((_antdConfig$locale = antdConfig.locale) === null || _antdConfig$locale === void 0 ? void 0 : _antdConfig$locale.locale);
  var intl = intlMap[localeString];
  //TODO intl可能不存在，需要一个默认语言兜底

  var getT = function getT(key) {
    return tabsLocale[key] || intl.getMessage(key, tabsLocale[key]);
  };
  var navigate = useNavigate();
  var closeOthers = function closeOthers() {
    var newPanes = panes.filter(function (pane) {
      return pane.path === pathname || pane.path === homePath;
    });
    var othersPanes = panes.filter(function (pane) {
      return pane.path !== pathname && pane.path !== homePath;
    });
    setPanes(newPanes);
    removeHistory(null, {
      retainPath: pathname
    });
    cleanOtherCache(newPanes.map(function (el) {
      return el.path;
    }));
    noticeSubAppRemovePanes(othersPanes, routesPaths);
  };
  var closeAllTabs = useMemoizedFn(function () {
    var homePane = panes.find(function (pane) {
      return pane.path === homePath;
    });
    var newPanes = homePane ? [homePane] : [];
    setPanes(newPanes);
    var panesWithoutHome = panes.filter(function (pane) {
      return pane.path !== homePath;
    });
    var nextActiveRoutePath = removeHistory();
    navigate(nextActiveRoutePath);
    cleanOtherCache(panesWithoutHome.map(function (el) {
      return el.path;
    }));
    noticeSubAppRemovePanes(panesWithoutHome, routesPaths);
  });
  var refreshTab = useMemoizedFn(function () {
    var currentRoute = flatPathRoutes[matchRoute.route.path];
    var dynamicPath = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.path;
    var willRefreshPane = _objectSpread({}, flatPathRoutes[dynamicPath]);
    var currentApp = microApps.find(function (app) {
      return (willRefreshPane.microAppPath || pathname).startsWith(app.baseRoute);
    });
    if (!currentApp) {
      setRefreshPath(pathname);
      return;
    }

    // 需要通知对应子应用
    var childPathname = getChildPathname(willRefreshPane.microAppPath || pathname, currentApp.baseRoute);
    var currentAppName = currentApp.name;
    var childPathnameWithParams = generatePath(childPathname, matchRoute.params || {});

    // 延迟处理pathname变更通知
    sendMessage(currentAppName, {
      event: "refreshPath",
      data: {
        path: childPathnameWithParams
      }
    });
  });
  useEffect(function () {
    // 缓存关闭所有tabs方法
    setPageHandlers({
      closeAll: closeAllTabs
    });
  }, []);
  var menus = [{
    key: "refresh",
    label: getT("refresh"),
    icon: /*#__PURE__*/_jsx(SyncOutlined, {}),
    onClick: refreshTab
  }, {
    key: "closeOthers",
    label: getT("closeOthers"),
    icon: /*#__PURE__*/_jsx(CloseOutlined, {}),
    onClick: closeOthers
  }, {
    key: "closeAll",
    label: getT("closeAll"),
    icon: /*#__PURE__*/_jsx(ClearOutlined, {}),
    onClick: closeAllTabs
  }];
  return /*#__PURE__*/_jsx(BarStyle, {
    children: /*#__PURE__*/_jsx(Space.Compact, {
      size: "small"
      //  style={getBarSpaceStyle()}
      ,
      children: /*#__PURE__*/_jsx(Dropdown, {
        onOpenChange: setTabHandlersDropdownOpen,
        menu: {
          items: menus
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "sa-tabs-bar-handler ".concat(tabHandlersDropdownOpen ? "handlers-icon-open" : ""),
          children: /*#__PURE__*/_jsx(DropdownArrow, {
            className: "sa-tabs-bar-handler-arrow"
          })
        })
      })
    })
  });
};
export default OperationRight;